import React from 'react';

function ProfileEdit(){

    return (
       
        <>

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Personal Information </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Name"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Surname"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>

<div class="row">


    <div class="col-sm-6">


          <div className="">
        
            <input
            type="tel"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Phone"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="tell"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Alternate Phone "
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>

<div class="row">

<div class="col-sm-12">
<hr style={{marginTop:"50px", marginBottom:"50px"}} />
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Address Information </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Address"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Street Name"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>

<div class="row">

<div class="col-sm-12">

</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Province"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="City"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>
        </>
    )
}

export default ProfileEdit;


